<template>
  <div class="card_con">
    <div class="card_img">
      <img :src="preCheckout.itemList[0].skuPic" alt="" />
    </div>
    <div class="font18 font_weight500 colo087 line_height_25 card_name">
      <div>
        {{ preCheckout.itemList[0].skuName }}
        {{ preCheckout.itemList[0].skuSpec }} ×{{
          preCheckout.itemList[0].amount
        }}
      </div>
      <tags :tradeType="preCheckout.itemList[0].tradeType" />
    </div>
    <div
      v-if="
        preCheckout.itemList &&
          preCheckout.itemList.length &&
          preCheckout.itemList[0].cardVoucher.effectStartAt
      "
      class="font12 font_weight400 line_height_17 colo055 card_date"
    >
      有效期：{{
        preCheckout.itemList[0].cardVoucher.effectStartAt
          | dateFormatterJava("YYYY-MM-DD")
      }}
      至
      {{
        preCheckout.itemList[0].cardVoucher.effectEndAt
          | dateFormatterJava("YYYY-MM-DD")
      }}
    </div>
    <div class="font16 font_weight600 line_height_19 colof00 card_money">
      <span>{{ preCheckout.itemList[0].price | currency(false) }}</span>
      <span
        v-if="false"
        class="font12 font_weight400 line_height_14 colo037 card_price"
        >¥450.00</span
      >
    </div>
    <div
      v-if="preCheckout.itemList && preCheckout.itemList.length"
      class="card_exp"
    >
      <van-divider
        :style="{ color: '#bf8264', borderColor: '#bf8264', padding: '0 15px' }"
      >
        鲜奶卡使用说明
      </van-divider>
    </div>
    <div
      v-if="preCheckout.itemList && preCheckout.itemList.length"
      class="card_list"
    >
      <div
        v-for="(item, index) in preCheckout.itemList[0].cardVoucher.legal"
        :key="index"
        class="list_item"
      >
        <div class="font12 font_weight400 line_height_14 colo087">
          <img src="@/assets/order/milk_card_star@2x.png" alt="" />
          <span class="card_item">{{ item.detail }}</span>
        </div>
        <img src="@/assets/order/icon_tips_outline_24@2x.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
const Tags = () => import("@/components/Tags").then(m => m.default || m);
export default {
  components: {
    Tags
  },
  data() {
    return {
      list: [
        "指定a2鲜奶赠送一瓶",
        this.$G("AZ会员随时赠送"),
        "可用于周期商品兑换"
      ]
    };
  },
  computed: {
    preCheckout() {
      return this.$store.getters.preCheckout;
    }
  }
};
</script>

<style lang="less" scoped>
.card_con {
  background: #fff;
  padding: 0 30px;
  .card_img {
    border-radius: 11px;
    img {
      width: 100%;
      display: block;
    }
  }
  .card_name {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .card_date {
    margin-top: 4px;
  }
  .card_money {
    padding: 12px 0;
    .card_price {
      text-decoration: line-through;
      padding-left: 4px;
    }
  }
  .card_exp {
    margin-top: 20px;
  }
  .card_list {
    margin-top: 30px;
    padding-bottom: 10px;
    .list_item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 20px;
      img {
        width: 16px;
        vertical-align: middle;
      }
      .card_item {
        margin-left: 8px;
        vertical-align: middle;
      }
    }
  }
}
</style>
